import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconNewWindowSvg } from "./IconNewWindowSvg.mjs";
const IconNewWindow = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconNewWindowSvg, ...svgProps }) });
export {
  IconNewWindow
};
